// extracted by mini-css-extract-plugin
export default {"container":"ModeSelection_container__oqB5n","buffer":"ModeSelection_buffer__rtK54"};